<template>
  <div>
    <!-- main entry -->
    <div id="app" :class="{ 'container-fluid': true, 'basic-layout': true, 'autoix-layout': $route.meta.appType === 'cabinet', 'control-panel-layout': $route.meta.appType === 'admin', 'developer-layout': $route.meta.appType === 'developer' }" >
      <Message v-if="$store.state.message.status"/>
      <router-view></router-view>
    </div>
    
    <!-- Loader -->
    <div class="global-loader" v-show="showLoader">
      <Loader />
    </div>
    
    <!-- button for side panel-->
    <div v-if="user !== null &&　user.is_superuser && (user.username === 'ict' || user.username === 'weian')" class="dev-panel-wrap">
      <div class="open-panel-button">
        <div class="btn btn-info" @click="showPanel"><span v-if="!openPanel">OpenPanel</span><span v-else>ClosePanel</span></div>
      </div>

      <!-- side panel for developer -->
      <transition name="slide-right">
        <div class="dev-panel" v-show="openPanel">
          <div class="btn btn-primary" @click="$store.dispatch('openDevice')">重新解鎖</div>
          <div class="btn btn-primary" @click="$store.dispatch('resetAndGetLocalSerialNumber')">重置藥櫃</div>
          <hr>
          <router-link :to="{ name: 'Main' }" class="btn btn-info">User Panel</router-link>
          <router-link :to="{ name: 'Admin' }" class="btn btn-info">Admin Panel</router-link>
          <router-link :to="{ name: 'DevPanel' }" class="btn btn-info">Developer Panel</router-link>
          <hr>
          <router-link :to="{ name: 'UserImport' }" class="btn btn-info">User Batch Import</router-link>
          <router-link :to="{ name: 'UserGroupSettings' }" class="btn btn-info">User Group Setting</router-link>

          <p v-if="currentDevice !== null">Current Device: {{ currentDevice.id }}</p>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
//import JQuery from 'jquery';
import { mapState } from 'vuex';
import server from './config';
import Message from './components/common/Message';
import Loader from './components/common/Loader';

//const $ = JQuery;

export default {
  name: 'app',
  data() {
    return {
      openPanel: false,
    };
  },
  components: {
    Message,
    Loader,
  },
  computed: mapState({
    errorDevices: state => state.device.errorDevices,
    currentDevice: state => state.device.currentDevice,
    instance: state => state.instance,
    user: state => state.user.user,
    logoutAccuTime: state => state.logoutAccuTime,
    connectionStatus: state => state.connectionStatus,
    showLoader: state => state.showLoader,
    logoutLimitSec: (state) => {
      if (state.generalSetting !== null) {
        return state.generalSetting.app_login_timeout * 60;
      }
      return null;
    },
    adminLogoutLimitSec: (state) => {
      return 60 * 60;
    },
  }),
  created() {
    this.resetTimeout();

    // mouse click, mouse hover, keypress event listener to reset timeout.
    window.addEventListener('click', () => {
      this.resetTimeout();
    });
    window.addEventListener('mouseover', () => {
      this.resetTimeout();
    });
    window.addEventListener('keypress', (event) => {
      this.resetTimeout();
    });

    $(window).on('beforeunload', () => {
      // due to axios can not perform sync request, thus we have to use ajax to perform sync request.
      // after unload, window won't wait async function finish. It will directly shutdown all procedures.
      // which leads to logout api cannot be called before window closed.
      if (this.$route.meta.appType === 'cabinet') {
        // logout record.
        const drugStorageId = this.$store.state.drugInDevice.currentDrugInDevice !== null ? this.$store.state.drugInDevice.currentDrugInDevice.id : undefined;
        $.ajax({
          type: 'POST',
          async: false,
          url: `${server}/api/event/`,
          dataType: 'json',
          data: {
            drugStorage: drugStorageId,
            employee: this.$store.state.user.user.id,
            event_type: 'LOGOUT',
          },
        });
        // set user offline
        $.ajax({
          type: 'POST',
          async: false, // this is the key!
          url: `${server}/api/user-offline/`,
          dataType: 'json',
          data: { user_id: this.$store.state.user.user.id },
        });
      }
    });
  },
  destroyed() {
    // this.$store.dispatch('sendCancelFingerCaptureCommand');
  },
  methods: {
    showPanel() {
      this.openPanel = !this.openPanel;
    },
    resetTimeout() {
      this.$store.dispatch('removeLogoutTimeout');
      this.$store.dispatch('setLogoutTimeout');
    },
  },
  watch: {
    logoutAccuTime(val) {
      // auto logout for cabinet
      if (val >= this.logoutLimitSec) {
        if (this.$route.meta.appType === 'cabinet' && this.$route.name !== 'Login') {
          this.$store.dispatch('setOffline')
          .then(() => {
            this.$store.dispatch('logout');
          });
          this.$store.commit('SET_MESSAGE', {
            type: 'success',
            context: '閒置時間過久，系統已自動登出',
          });
          this.$router.push({ name: 'Login' });
        }
      }
      // auto logout for admin
      if (val >= this.adminLogoutLimitSec) {
        if (this.$route.meta.appType === 'admin' && this.$route.name !== 'AdminLogin') {
          this.$store.dispatch('logout');
          this.$store.commit('SET_MESSAGE', {
            type: 'success',
            context: '閒置時間過久，系統已自動登出',
          });
          this.$router.push({ name: 'AdminLogin' });
        }
      }
    },
    connectionStatus(val) {
      if (val === 'error') {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '連線失敗，嘗試重新連線中',
          confirm: false,
        });
      }
      if (val === 'success') {
        this.$store.commit('CLOSE_MESSAGE');
      }
    },
    errorDevices(val) {
      if (val.length > 0) {
        this.resetTimeout();
      }
    },
  },
};
</script>

<style lang="sass">
@import '~bootstrap/dist/css/bootstrap.css'

@font-face
  font-family: 'cwTeXHei'
  src: url('./assets/fonts/cwTeXHei-zhonly.ttf');

@keyframes AnimationBack
  0%
    background-position: 50% 0%
  50%
    background-position: 100% 100%
  100%
    background-position: 50% 0%


.open-panel-button
  display: block
  height: 38px
  position: absolute;
  left: -110px;

.dev-panel-wrap
  border-left: 1px solid black
  z-index: 2001
  position: fixed
  height: 100%;
  right: 0px;
  top: 0px;
  display: flex
  .dev-panel
    width: 150px
    background-color: white
    *
      display: block

// slide
.slide-right-enter-active, .slide-right-leave-active 
  transition: all .3s ease;

.slide-right-enter
  transform: translate(100%, 0)

.slide-right-leave-to
  transform: translate(100%, 0)

// slide
.slide-down-enter-active, .slide-down-leave-active 
  transition: all .3s ease;

.slide-down-enter
  // transform: translate(0, -100%)

.slide-down-leave-to
  // transform: translate(0, 100%)
  height: 0



// slide-fade
.slide-fade-enter-active, .slide-fade-leave-active 
  transition: all .2s ease;

.slide-fade-enter
  opacity: 0

.slide-fade-leave-to
  opacity: 0

body
  background-image: url('assets/img/background_images_3d_001.jpg')
  // background-color: #e2e2e2
  font-family: sans-serif;
  // *
  //   user-select: none;
  

.autoix-layout
  width: 1000px
  margin: 14px auto;
  // max-height: 740px
  // overflow: hidden
  // border: 1px solid;
  // border-radius: 10px
  // box-shadow: 0 1px 5px rgba(0,0,0,.2), 0 2px 2px rgba(0,0,0,.14), 0 3px 1px -2px rgba(0,0,0,.12)
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2), 0 5px 10px rgba(0, 0, 0, 0.14), 0 4px 3px -2px rgba(0, 0, 0, 0.12)
  *
    user-select: none;

.basic-layout
  background-color: white

.control-panel-layout
  min-height: 101vh
  background-color: transparent
  overflow-y: auto
  

.btn
  // border-radius: 0px


.content-panel
  // background-color: white;
  // border: 1px solid rgba(0,0,0,0.3);
  // border-radius: 10px;
  // padding: 10px;
  // margin: 0px 10px;
  // box-shadow: 0 2px 2px 0 rgba(0,0,0,.14), 0 3px 1px -2px rgba(0,0,0,.2), 0 1px 5px 0 rgba(0,0,0,.12);
  .upper-subpanel
    height: 560px;
    .col-6
      height: 100%
  .lower-subpanel-wrap
    margin: 0 -15px;
    background: darken(#f4f4f4, 5%);
    // border-radius: 0px 0px 10px 10px;
    border-top: 1px solid rgba(0,0,0,0.05);
    height: 105px;
    justify-content: space-between;
    padding: 0px 10px;
    align-items: center;
    display: flex

.upper-subpanel--inside
  height: 100%
  width: 100%
  display: flex
  align-items: center
  justify-content: center
  position: relative;

.upper-subpanel--without-progressbar
  height: calc(100% - 100px)
  width: 100%
  margin: 0px

.control-button
  width: 90px;
  height: 90px;
  padding: inherit;
  transition: all 0.1s
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12);
  &:active
    -moz-box-shadow:    inset 0 0 20px #000000;
    -webkit-box-shadow: inset 0 0 20px #000000;
    box-shadow:         inset 0 0 20px #000000;
  .button-inside-wrap
    height: 100%
    width: 100%
    display: flex
    flex-direction: column
    align-items: center;
    justify-content: center;
    white-space: normal

    

.control-button-red
  background: #FF3811
  color: white
  .button-inside-wrap
    color: white
    a 
      color: white
    p
      margin: 0

.confirm-button
  background: #FF3811;
  color: white;
  border-radius: 5px;
  margin-top: 10px

/* vue transition css */
.fade-enter-active, .fade-leave-active
  transition: opacity .2s

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
  opacity: 0

.with-child-centered
  display: flex
  align-items: center
  justify-content: center
  height: 100%
  flex-flow: column

// shared sass
.drug-search-input
  padding: 1.0rem 0.75rem;
  margin: 3%;
  width: 80%

.drug-search-wrap
  height: 100%

  .form-control
    margin: 1% 0%

.drug-search-list
  height: 87%;
  // margin: 2% 0;
  overflow-y: auto;
  overflow-x: hidden;
  &::-webkit-scrollbar-track
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 15px;
    background-color: #F5F5F5;
  &::-webkit-scrollbar
    width: 12px;
    background-color: #F5F5F5;  
  &::-webkit-scrollbar-thumb
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
    background-color: #555;
  

.drug-button
  display: flex
  width: 100%;
  padding: 5px 2px 5px 5px;
  margin: 4px 0px
  border-radius: 5px
  text-align: left;
  box-shadow: 0 2px 2px 0 rgba(0,0,0,.14), 0 3px 1px -2px rgba(0,0,0,.2), 0 1px 5px 0 rgba(0,0,0,.12);
  background-color: #f4f4f4
  border-color: #dbdbdb
  color: black
  .drug-generic-name
    font-size: 10px
    color: rgba(0,0,0,0.5)

.drug-head
  display: flex
  flex-direction: row
  align-items: center
  overflow: hidden
  background: white
  background: gainsboro;
  margin: -5px 0px -5px -5px;
  width: 40%;
  padding: 10px 5px;
  transition-duration: 0.3s
  border-radius: 4px
  // border-bottom-right-radius: 0px;
  // border-top-right-radius: 0px;
  .drug-head--content
    margin-left: 14px
    display: flex
    justify-content: center;
    flex-direction: column
    font-size: 14px
    p
      font-size: 10px
      color: grey
      white-space: initial;
      margin: 0px
  .drug-head-icon-wrap
    display: flex
    flex-direction: column
    flex-direction: row
    align-items: center
    


.drug-item
  #position, #patch
    width: 132px
  #max-amount, #expired-date
    width: 120px
  

.info-col
  display: inline-block
  padding: 0 5px
  .info-col-head
    border-bottom: 1px solid rgba(0,0,0,0.3)
    font-size: 14px
    color: cadetblue
  .info-col-content
    overflow: hidden
    height: fit-content
    span, p 
      font-size: 14px
    p
      margin: 0

.drug-selected
  .drug-head
    background: cadetblue
    color: white
    p
      color: white

.confirm-form
  height: 375px
  display: flex
  flex-flow: column
  justify-content: center;
  width: 100%;
  margin: auto;
  .form-group
    display: flex;
    flex-direction: column;
    align-items: center;
    .custom-input
      height: 45px
      font-size: 1rem
      width: 65%
      text-align: center

  label
    padding-right: 10px
  .button-wrap
    text-align: center
    button
      width: 200px
  .fake-button-wrap
    position: absolute;
    bottom: -98px;
    right: 14px;

  .form-inline
    padding-right: 72px
    .form-group
      padding-bottom: 30px

.confirm-form-with-syspanel
  height: 235px
  text-align: center
  h5
    margin: 0

.event-list
  height: 96%;
  margin: 1%;
  .upper-subpanel--inside
    height: 90%
  .drug-head
    width: 35%
  .drug-item
    width: 65%
    padding-left: 1%
    text-align: left

.item-selected
  //box-shadow: inset 0 0 10px #000000;
  background-color: cadetblue
  color: white
  span
    color: white !important

.confirm-layout
  margin-top: 10px

.alert
  margin: 0
  padding: 0.5rem 1.25rem

.drug-location
  margin: 0;
  font-size: 12px;

.icon-right
  float: right
  margin-bottom: 10px

.create-form
  padding: 2%
  margin: 2% 0
  border: 1px solid gray
  background: white
  right: 0px
  z-index: 10

input[type=number]::-webkit-outer-spin-button,
input[type=number]::-webkit-inner-spin-button
  -webkit-appearance: none;
  margin: 0;

.admin-layout
  padding: 20px 0
  position: relative

.table
  background: white !important

.modal
  display: flex
  flex-direction: column
  justify-content: center;
  align-items: center;
  background: rgba(0,0,0,0.3);

.modal-dialog
  // margin-top: 300px !important
  width: 500px !important
  .modal-body
    max-height: 75vh;
    overflow-y: auto;

.modal-error
  border-color: #FF3811
  background-color: #FF3811
  color: white

.modal-warning
  border-color: #ff960c
  background-color:#ff960c
  color: white

.modal-success
  border-color: #42b883
  background-color: #42b883
  color: white  

.modal-footer
  justify-content: center
  border: 0
  .btn
    border: 1px solid white

.search-dynamic
  position: relative
  display: flex

.input-options-wrap
  z-index: 100
  width: 100%
  position: absolute
  top: 38px
  background-color: white
  border: 1px solid rgba(0, 0, 0, 0.3)
  max-height: 300px
  overflow-y: auto
  overflow-x: hidden
  .input-option
    padding: 2px 5px
    &:hover
      background-color: #6f7e95
      color: white

.global-loader
  position: absolute;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
  background-color: rgba(255,255,255,0.8);
  .v-clip
    width: 70px !important
    height: 70px !important

.med-button
  margin: 5px 5px
  box-shadow: 0 2px 2px 0 rgba(0,0,0,.14), 0 3px 1px -2px rgba(0,0,0,.2), 0 1px 5px 0 rgba(0,0,0,.12);
  // border: 1px solid transparent
  background-color: #f4f4f4
  border-color: #dbdbdb
  display: flex;
  justify-content: space-between;
  transition: all ease 0.3s
  padding: 5px 10px
  #med_desc
    h6
      margin: 0.5rem
      &:nth-child(2)
        font-size: 12px
  #remain_amount
    border-left: 1px solid rgba(0,0,0,0.2)
    padding: 5px 15px
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
    span
      font-size: 20px
      &:first-child
        font-size: 12px

.med-group-wrapper
  height: 100%
  display: flex
  flex-direction: column
  

.med-select
  height: calc(100% - 40px)
  overflow-y: auto
  &::-webkit-scrollbar-track
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 10px;
    background-color: #F5F5F5;
  &::-webkit-scrollbar
    width: 6px;
    background-color: #F5F5F5;  
  &::-webkit-scrollbar-thumb
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
    background-color: #555;

.unselectable
  pointer-events: none;
  box-shadow: none;
  border-style: unset
  color: rgba(0,0,0,0.3)
  .amount-button
    background-color: rgba(0,0,0,0.3) !important
  #remain_amount
    color: red

.selected-med-button
  background: cadetblue
  color: white
  #remain_amount
    border-color: white


.group-select
  display: table
  flex-direction: column
  border-collapse: collapse
  .group-button
    display: table-cell
    text-align: center
    background-color: steelblue
    color: white
    padding: 10px
    border: 1px solid white


.nav-autoix
  width: 100%
  // box-shadow: 0px -2px 10px rgba(0, 0, 0, 0.2);
  // border-bottom: 1px solid rgba(0,0,0,0.2)
  .active
    background-color: steelblue !important
  .nav-link
    background-color: aliceblue
    border-radius: 0  



$switch-height: 20px

.switch-wrapper
  display: flex
  align-items: center

.switch
  position: relative
  display: inline-block;
  width: 46px
  height: $switch-height
  border-radius: 5px
  margin-right: 10px
  input
    display: none
  .slider-on
    background-color: cadetblue !important
  .slider-on:before
    transform: translateX(26px);
  .slider
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: .2s;
    margin: 0
    border-radius: 10px
    &:before
      position: absolute;
      content: "";
      height: calc(#{$switch-height} - 8px);
      width: calc(#{$switch-height} - 8px);
      left: 4px;
      bottom: 4px;
      background-color: white;
      transition: .4s;
      border-radius: 10px

</style>



// WEBPACK FOOTER //
// App.vue?5f3ecb66